import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountPage} from 'src/openapi/admin/apis/AccountInfoApi';
import {getAccountName} from 'src/openapi/admin/apis/GetAccountNameApi';
import {useAppDispatch} from 'src/store/hooks';

import type {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';

export const useSsoParentAccount = ({accountId}: {accountId: number}) => {
    const apiDispatch = useAppDispatch();
    const getDispatchAction = useCallback(async (signal: AbortSignal) => {
        const accountResponse = await apiDispatch(getAccountPage({accountId}, {signal}));
        if (accountResponse.payload.error) {
            return {type: '', payload: accountResponse.payload};
        }

        const parentId = accountResponse.payload.data.parentAccountId;
        let parentAccount: AccountShortInfo | undefined;
        if (parentId) {
            const nameResponse = await apiDispatch(getAccountName({requestBody: [parentId]}, {signal}));
            if (nameResponse.payload.error) {
                return {type: '', payload: nameResponse.payload};
            }
            parentAccount = {accountId: parentId, accountName: nameResponse.payload.data[parentId] || String(parentId)};
        }
        return {type: '', payload: {success: true as const, error: false as const, data: parentAccount}};
    }, [accountId, apiDispatch]);

    return useReadOnlyDataHook<AccountShortInfo | undefined>({getDispatchAction, initValue: undefined});
};
